import gql from 'graphql-tag';

import { BPF_CHANGELOG_VIEW_MODEL_FRAGMENT } from './fragments';

export const GET_BPF_CHANGELOG_LIST = gql`
  ${BPF_CHANGELOG_VIEW_MODEL_FRAGMENT}
  query GetBpfChangelogList($input: BpfChangelogListInput!) {
    bpf {
      result: changelogList(input: $input) {
        success
        error
        items {
          ...BpfChangelogViewModelFields
        }
        pagination {
          page
          perPage
          total
          totalPages
        }
      }
    }
  }
`;
